const dashboardIcon = require('../assets/icons/common/dashboard.svg').default;
const accountIcon = require('../assets/icons/common/account.svg').default;
const legalIcon = require('../assets/icons/common/legal.svg').default;
const settingsIcon = require('../assets/icons/common/Settings.svg').default;
const supportIcon = require('../assets/icons/common/information.svg').default;
const taskIcon = require('../assets/icons/common/tasks.svg').default;

export const items = [
    {
        title: 'Dashboard',
        icon: dashboardIcon,
        path: '',
        active: true,
    },
    {
        title: 'Account',
        icon: accountIcon,
        path: 'account',
        active: false,
    },
    {
        title: 'Exams',
        icon: taskIcon,
        path: 'exams',
        active: false,
    },
    {
        title: 'Legal',
        icon: legalIcon,
        path: 'legal'
    },
    {
        title: 'Settings',
        icon: settingsIcon,
        path: 'settings'
    },
    {
        title: 'Support',
        icon: supportIcon,
        path: 'support'
    },
];